// import React, { Component } from "react";
// import { Breadcrumb } from "@gull";
// import { Table } from "react-bootstrap";
// import ReactPaginate from "react-paginate";
// import SimpleCard from "@gull/components/cards/SimpleCard";
// import { classList } from "@utils";
// import PropTypes from "prop-types";
// import { connect } from "react-redux";
// import { withRouter } from "react-router-dom";
// import { Helmet } from "react-helmet";

// class Dashboard extends Component {
//   render() {
//     return (
//       <div>
//         <Helmet>
//           <title>Master Admin Dashboard </title>
//         </Helmet>
//         <Breadcrumb
//           routeSegments={[
//             { name: "Master Admin Dashboard - " + this.props.user.name },
//           ]}
//         >
//           {" "}
//         </Breadcrumb>
//       </div>
//     );
//   }
// }

import { Breadcrumb } from "@gull";
import React from "react";
import { Helmet } from "react-helmet";

function Dashboard() {
  return (
    <div>
      <div>
        <Helmet>
          <title>Master Admin Dashboard </title>
        </Helmet>
        <Breadcrumb
          routeSegments={[{ name: "Master Admin Dashboard - " }]}
        ></Breadcrumb>
      </div>
    </div>
  );
}

export default Dashboard;
